// Pure helpers for the Supabase client: URL normalization and error
// classification. Kept free of import.meta so they are unit-testable in node.

// The client wants the BASE project origin (https://<ref>.supabase.co). It
// appends /rest/v1/ itself, so a value with a path or trailing slash produces
// "Invalid path specified in request URL". Normalize to the origin only.
export function normalizeUrl(raw) {
  if (!raw || !raw.trim()) return { baseUrl: null, urlError: null };
  try {
    const u = new URL(raw.trim());
    if (u.protocol !== 'http:' && u.protocol !== 'https:') {
      return { baseUrl: null, urlError: `VITE_SUPABASE_URL must be http(s): "${raw}"` };
    }
    return { baseUrl: u.origin, urlError: null }; // origin drops path + trailing slash
  } catch {
    return {
      baseUrl: null,
      urlError: `VITE_SUPABASE_URL is not a valid URL: "${raw}". Use the base project URL, e.g. https://<ref>.supabase.co (no /rest/v1/ path).`,
    };
  }
}

// Turn a raw Supabase/PostgREST error into a specific, actionable message so a
// malformed URL, an auth failure, and an unexposed schema never collapse into
// one generic "path" error again.
export function describeSupabaseError(error) {
  if (!error) return null;
  const code = error.code || '';
  const status = error.status || error.statusCode || 0;
  const msg = (error.message || '').toLowerCase();

  if (
    msg.includes('invalid path') ||
    msg.includes('invalid url') ||
    msg.includes('failed to fetch') ||
    msg.includes('networkerror')
  ) {
    return `Cannot reach Supabase. Check VITE_SUPABASE_URL is the base project URL (https://<ref>.supabase.co) with no /rest/v1/ path. [${error.message}]`;
  }

  if (code === 'PGRST106' || status === 406 || msg.includes('schema must be one of')) {
    return `Schema "uee" is not exposed to the API. Add "uee" in Supabase Dashboard → API → Exposed schemas. [${error.message}]`;
  }

  if (
    status === 401 ||
    code === '42501' ||
    code === 'PGRST301' ||
    msg.includes('api key') ||
    msg.includes('jwt') ||
    msg.includes('permission denied')
  ) {
    return `Authentication or permission failure. Check VITE_SUPABASE_ANON_KEY, table GRANTs, and RLS policies. [${error.message}]`;
  }

  return error.message || String(error);
}
